import IReactiveJob from '../app/interfaces/reactiveJob';
import moment from "moment";
import PlannedJob from "../app/interfaces/plannedJob";

const calculateStatus = (jobList: [any]) => {

  const getTimeDifferenceToNow = (date: string, time:string) => {
    const estimated = moment(date + ' '+time,'YYYY-MM-DD H:mm:ss');
    const current = moment();
    const difference = moment.duration(estimated.diff(current)).asHours();
    if(difference < 0 ) return Math.floor(difference);
    return Math.ceil(difference);
  };

  const getTimeDifferenceToCriteria = (job: IReactiveJob, criteria:string) => {
    let estimated;
    let actual;
    switch(criteria) {
      case 'onsite':
        estimated = moment(job.SLAOnsiteEstimated + ' ' + job.SLAOnsiteEstimatedTime, 'YYYY-MM-DD H:mm:ss');
        actual = moment(job.SLAOnsiteActual + ' ' + job.SLAOnsiteActualTime, 'YYYY-MM-DD H:mm:ss');
        break;
      case 'completed':
        estimated = moment(job.SLACompleteEstimated + ' ' + job.SLACompleteEstimatedTime, 'YYYY-MM-DD H:mm:ss');
        actual = moment(job.SLACompleteActual + ' ' + job.SLACompleteActualTime, 'YYYY-MM-DD H:mm:ss');
        break;
    }
    const difference = moment.duration(estimated.diff(actual)).asHours();
    if(difference < 0) return Math.floor(difference);
    return Math.ceil(difference);
  };

  const computeSLA = (job: IReactiveJob, criteria: string) => {
    let criteriaActual;
    let criteriaEstimated;
    let criteriaEstimatedTime;

    switch (criteria) {
      case 'onsite':
        criteriaActual = job.SLAOnsiteActual;
        criteriaEstimated = job.SLAOnsiteEstimated;
        criteriaEstimatedTime = job.SLAOnsiteEstimatedTime;
        break;
      case 'completed':
        criteriaActual = job.SLACompleteActual;
        criteriaEstimated = job.SLACompleteEstimated;
        criteriaEstimatedTime = job.SLACompleteEstimatedTime;
        break;
    }

    if (criteriaActual == "") {
      const timeDifference = getTimeDifferenceToNow(criteriaEstimated, criteriaEstimatedTime);

      if (timeDifference > 2) {
        return 'upcoming';
      } else if (timeDifference > 1 && timeDifference <= 2) {
        return 'upcomingToday';
      } else if (timeDifference >= 0 && timeDifference <= 1) {
        return 'urgentlyUpcoming';
      } else if (timeDifference < 0) {
        return 'missedDeadline';
      }
    } else {
      const timeDifference = getTimeDifferenceToCriteria(job, criteria);
      if (timeDifference >= 0) {
        return 'doneOnTime';
      } else if (timeDifference < 0) {
        return 'missedDeadline';
      }
    }
  };

  const computeStatus = (job: IReactiveJob) => {
    if(job.Status == 'Finished') return 'finished';
    if(job.Status == 'Cancelled') return 'cancelled';
    if(job.SLACompleteActual != "") return "workCompleted";
    if(job.HoldReason != "" && job.HoldReason != "Hold Reason not defined") return "onHold";
    if(job.SLAOnsiteActual != "") return 'inProgress';
    if(job.NumberEngineers > 0) return "allocated";
    return "new";
  };

  const computeCriticalStatus = (job: IReactiveJob) => {
    return job.PriorityCode;
  };

  jobList.forEach((job: IReactiveJob) => {
    job.SLAOnsiteEstimatedDateTime = job.SLAOnsiteEstimatedTime + ' ' + job.SLAOnsiteEstimated;
    job.SLAOnsiteActualDateTime = job.SLAOnsiteActualTime + ' ' + job.SLAOnsiteActual;
    job.SLACompleteEstimatedDateTime = job.SLACompleteEstimatedTime + ' ' + job.SLACompleteEstimated;
    job.SLACompleteActualDateTime = job.SLACompleteActualTime + ' ' + job.SLACompleteActual;
    job.SLAOnsite = computeSLA(job, 'onsite');
    job.SLAComplete = computeSLA(job, 'completed');
    job.Status = computeStatus(job);
    job.CriticalStatus = computeCriticalStatus(job);
  });

  return jobList;
};

export const computePlannedStatus = (jobList: [PlannedJob]) => {
  jobList.forEach((job: PlannedJob) => {
    if(job.StatusCode == '') {
      job.Status = 'Open'
    } else if( job.StatusCode == 'F') {
      if(job.Reason != '') {
        job.Status = 'Incomplete'
      } else {
        job.Status = 'Completed'
      }
    }
  });
  return jobList;
};

export default calculateStatus;